import api from "@/api/api"
import actions from "./actions"
import mutations from "./mutations";
export default  {
    namespaced: true,
    state: () => ({ 
        layout: 'app',
        isLoading: false,
        catalogCount: { categoryCount: 0, subCategoryCount: 0 }
     }),
    mutations: mutations,
    actions: actions,
    getters: {
        isLoading(state) {
            return state.isLoading;
        },
      }
  }
